import React, { useState } from 'react';
import { Info } from 'lucide-react';

export interface MetadataEntry {
    label: string;
    date?: string;
    userName?: string;
}

interface MetadataInfoButtonProps {
    entries: MetadataEntry[];
}

export const MetadataInfoButton: React.FC<MetadataInfoButtonProps> = ({
    entries,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    if (entries.length === 0) {
        return null;
    }

    return (
        <span
            style={{ position: 'relative', display: 'inline-flex' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <span
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '4px',
                    cursor: 'pointer',
                    color: '#6c757d',
                }}
            >
                <Info size={16} />
            </span>
            {isHovered && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '8px',
                        padding: '8px 12px',
                        backgroundColor: '#333',
                        color: '#fff',
                        borderRadius: '6px',
                        fontSize: '13px',
                        whiteSpace: 'nowrap',
                        zIndex: 1000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        pointerEvents: 'none',
                    }}
                >
                    {entries.map((entry, index) => (
                        <div key={index} style={{ marginBottom: index < entries.length - 1 ? '6px' : 0 }}>
                            <div style={{ fontWeight: 500 }}>{entry.label}:</div>
                            {entry.date && <div>{entry.date}</div>}
                            {entry.userName && <div style={{ opacity: 0.85 }}>{entry.userName}</div>}
                        </div>
                    ))}
                    <div
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            borderLeft: '6px solid transparent',
                            borderRight: '6px solid transparent',
                            borderTop: '6px solid #333',
                        }}
                    />
                </div>
            )}
        </span>
    );
};
